import config from '../../config'
import { USER_LOGGED_OUT, USER_LOGGED_IN } from '../constants/user'
import { ALERT_DISPLAY } from '../constants/alert'

import { checkTokenExpiration } from '../utils/checkTokenExpiration'
import { isNullOrEmpty } from './../utils/utilities'
import { OKTA_VERSIONS } from '../constants'

import { signOut, signOutIdx, resetPasswordLegacy } from '../../lib/authentication'

export function logout() {
  return (dispatch) => {
    const signOutPromise = OE_ENV.OKTA_VERSION === OKTA_VERSIONS.V2 ? signOutIdx : signOut
    signOutPromise().then(() => {
      window.location.replace(`${config.landingPageUrl}`)
      dispatch({ type: USER_LOGGED_OUT })
    })
  }
}

export function userConfirmPassword(recoveryToken, newPassword, onSuccess, onFailure) {
  return resetPasswordLegacy(recoveryToken, newPassword, onSuccess, onFailure)
}

export function editProfile(user, values) {
  return new Promise((resolve, reject) => {
    checkTokenExpiration(user).then(() => {
      const paramsArray = [
        { fieldName: 'firstName', fieldValue: values.firstName },
        { fieldName: 'lastName', fieldValue: values.lastName },
        {
          fieldName: 'title',
          fieldValue: isNullOrEmpty(values.jobTitle) ? ' ' : values.jobTitle,
        },
        { fieldName: 'phone', fieldValue: values.phone },
        {
          fieldName: 'phoneExt',
          fieldValue: isNullOrEmpty(values.phoneExt) ? ' ' : values.phoneExt,
        },
      ]

      apigClient.profileIdPut({ id: user.id }, paramsArray).then((resp2, err1) => {
        if (resp2.data && resp2.data.success === true) {
          return resolve({
            success: true,
            data: resp2.data,
          })
        }
        return resolve({
          success: false,
          message: err1.message,
        })
      })
    })
  })
}

export function updateUserValues(values) {
  return (dispatch, getState) => {
    const { user } = getState()
    dispatch({
      type: USER_LOGGED_IN,
      payload: {
        ...user,
        title: values.jobTitle,
        phoneExt: values.phoneExt,
        phone: values.phone,
        lastName: values.lastName,
        firstName: values.firstName,
      },
      meta: { from: 'updateUserValues' },
    })
  }
}

export function createAlert(message, bsStyle, timeout = null, fnAfterAlert = () => {}) {
  return (dispatch) => {
    dispatch({
      type: ALERT_DISPLAY,
      payload: {
        message,
        bsStyle,
        show: true,
      },
    })
    if (timeout !== null) {
      setTimeout(() => {
        dispatch({
          type: ALERT_DISPLAY,
          payload: {
            message: '',
            show: false,
          },
        })
        fnAfterAlert()
      }, timeout)
    }
  }
}
